import React from 'react';
import { Bar } from 'react-chartjs-2';

const MillionMarksChart = () => {
  const data = {
    labels: ['2019', '2020', '2021', '2022', '2023'],
    datasets: [
      {
        label: 'Total Throughput (Million Tons)',
        data: [1.85, 1.65, 1.92, 2.02, 2.18],
        backgroundColor: [
          'rgba(77, 166, 255, 0.7)',
          'rgba(255, 99, 132, 0.7)',
          'rgba(255, 159, 64, 0.7)',
          'rgba(76, 217, 100, 0.7)',
          'rgba(153, 102, 255, 0.7)'
        ],
        borderColor: [
          '#4da6ff',
          '#ff6384',
          '#ff9f40',
          '#4cd964',
          '#9966ff'
        ],
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Million Tons'
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      },
      x: {
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      }
    },
    plugins: {
      legend: {
        position: 'top',
      }
    }
  };

  return <Bar data={data} options={options} />;
};

export default MillionMarksChart;